export default function ContactPrayerDayClosed() {
    return (
        <p className="closed">Vi har lukket d. 5 &nbsp;juni på grundlovsdag.</p>
    )
}
